import React from 'react'
import { Box } from '@mui/system'
import List from '@mui/material/List'
import Collapse from '@mui/material/Collapse'

export const TopSearchResultList = React.forwardRef<HTMLDivElement, React.PropsWithChildren<{}>>((props, ref) => {
  const { children } = props

  return (
    <Box ref={ref}>
      <Collapse unmountOnExit mountOnEnter timeout='auto' in appear>
        <List {...props}>{children}</List>
      </Collapse>
    </Box>
  )
})
